
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class DimIndexesDialog extends Serenity.EntityDialog<DimIndexesRow, any> {
        protected getFormKey() { return DimIndexesForm.formKey; }
        protected getIdProperty() { return DimIndexesRow.idProperty; }
        protected getLocalTextPrefix() { return DimIndexesRow.localTextPrefix; }
        protected getService() { return DimIndexesService.baseUrl; }
        protected getDeletePermission() { return DimIndexesRow.deletePermission; }
        protected getInsertPermission() { return DimIndexesRow.insertPermission; }
        protected getUpdatePermission() { return DimIndexesRow.updatePermission; }

        protected form = new DimIndexesForm(this.idPrefix);

    }
}